<script setup>
import {computed} from 'vue'
import {useRoute} from 'vue-router'

const route = useRoute()
const active = computed(() => route.name)
</script>


<template>
    <van-tabbar :modelValue="active">
        <van-tabbar-item icon="home-o" name="home" to="/"/>
        <van-tabbar-item icon="search" name="libraryList" to="/library"/>
        <van-tabbar-item icon="shield-o" name="productList" to="/product"/>
        <van-tabbar-item icon="chat-o" name="message" to="/message"/>
        <van-tabbar-item icon="contact" name="account" to="/account"/>
    </van-tabbar>
</template>
